/**
 * PAPPO — useNavLayout
 * Decide como a navegação principal é exibida:
 *  - Celular (tela estreita): SEMPRE barra inferior (estilo WhatsApp).
 *  - PC: preferência do utilizador — lateral (padrão) ou inferior — persistida.
 */
import { useCallback, useEffect, useState } from 'react';

export type NavPos = 'lateral' | 'inferior';

const STORAGE_KEY = 'pappo_nav_pos';
const MOBILE_QUERY = '(max-width: 768px)';

function lerPreferencia(): NavPos {
  return localStorage.getItem(STORAGE_KEY) === 'inferior' ? 'inferior' : 'lateral';
}

export function useNavLayout() {
  const [navPos, setNavPosState] = useState<NavPos>(lerPreferencia);
  const [isMobile, setIsMobile] = useState<boolean>(
    () => window.matchMedia(MOBILE_QUERY).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  const setNavPos = useCallback((pos: NavPos) => {
    localStorage.setItem(STORAGE_KEY, pos);
    setNavPosState(pos);
  }, []);

  // No celular a barra é sempre inferior; no PC respeita a preferência.
  const variant: 'rail' | 'bottom' =
    isMobile || navPos === 'inferior' ? 'bottom' : 'rail';

  return { navPos, setNavPos, isMobile, variant };
}
